module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8r7r2n5r-956f4c23138fe066d0769c2d7f74dca2.svg";